import 'core-js/modules/es.number.constructor.js';

var noop = function noop() {
  //
};
var notEqual = function notEqual(valueA, valueB) {
  // This ensures (valueB==NaN, valueA==NaN) always returns false.
  return valueB !== valueA && (valueB === valueB || valueA === valueA);
};
var equal = function equal(valueA, valueB) {
  return !notEqual(valueA, valueB);
};
var isNull = function isNull(value) {
  return value === null;
};
var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};
var isNil = function isNil(value) {
  return isNull(value) || isUndefined(value);
};
var isObject = function isObject(value) {
  return (value === null || value === void 0 ? void 0 : value.constructor) === Object;
};
var isNumber = function isNumber(value) {
  return typeof value === 'number' && !Number.isNaN(value);
};
var isString = function isString(value) {
  return typeof value === 'string';
};
var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

// eslint-disable-next-line @typescript-eslint/ban-types
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
var isArray = function isArray(value) {
  return Array.isArray(value);
};
var isWindow = function isWindow(value) {
  return value === window;
};

export { notEqual as a, isUndefined as b, isNil as c, isObject as d, equal as e, isNumber as f, isString as g, isBoolean as h, isNull as i, isFunction as j, isArray as k, isWindow as l, noop as n };
